import React from "react";
import { Box, Collapse, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import "./styles/ContentRow.scss";
import TypeIconReturner from "../../../components/TypeIconReturner/TypeIconReturner";
import SheetIcon from "../../../components/VectorIcons/SheetIcon";

// Renders an inline list of names separated by a pipe ("|").
const PeopleList = ({ items }) => (
  <>
    {items.map((name, index) => (
      <Box key={index} display="flex" alignItems="center">
        <Typography component="span" variant="inherit">
          {name}
        </Typography>
        {index + 1 < items.length && (
          <Typography
            component="span"
            className="creatorSeparator"
            variant="inherit"
          >
            |
          </Typography>
        )}
      </Box>
    ))}
  </>
);

// Dumb project/parent row. Presentation only: the expand/collapse state is
// controlled by the parent through `expanded` + `onToggle`. Pass `alwaysOpen`
// to keep the content open and hide the toggle affordance.
const ContentRow = ({
  iconType,
  title,
  people = [],
  detailsText,
  origins = [],
  lastAttachmentText,
  sheetLink,
  expanded = false,
  onToggle,
  alwaysOpen = false,
  disabled = false,
  children,
}) => {
  const isOpen = alwaysOpen || expanded;
  const handleToggle = alwaysOpen ? undefined : onToggle;

  return (
    <Box className={`listItem${disabled ? " disabled" : ""}`}>
      <Box className="projectDetails" onClick={handleToggle}>
        <Box component="li" className="title">
          {!alwaysOpen && (
            <div
              className="itemArrow"
              style={isOpen ? { transform: "rotate(90deg)" } : undefined}
            />
          )}
          <TypeIconReturner type={iconType} responsiveIcon />
          <span className="projectTitle">{title}</span>
        </Box>

        <Box component="li" className="creator">
          <PeopleList items={people} />
        </Box>

        <Box component="li" className="details">
          <Typography component="span" variant="inherit">
            {detailsText}
          </Typography>
        </Box>

        <Box component="li" className="origin">
          {origins.map((origin, index) => (
            <div key={index}>
              <span>{origin}</span>
              {index + 1 < origins.length && (
                <span className="creatorSeparator">|</span>
              )}
            </div>
          ))}
        </Box>

        <Box component="li" className="lastAttachment">
          <span>{lastAttachmentText}</span>
        </Box>

        <Box component="li">
          <Tooltip
            title={
              <Typography variant="body2" sx={{ fontFamily: "Globotipo Text" }}>
                Abrir ficha do projeto: <strong>{title}</strong>
              </Typography>
            }
            arrow
            placement="top"
          >
            <Link to={sheetLink}>
              <SheetIcon />
            </Link>
          </Tooltip>
        </Box>
      </Box>

      <Collapse in={isOpen} timeout={0} unmountOnExit>
        <Box>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default ContentRow;
